import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { useMemo } from 'react';
import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';

const Profile_4 = ({ item }) => {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const customization = staticComponentValueConverter(item?.customization);
  const itemColor = useMemo(() => HexToHueConverter(customization?.itemColor), [customization?.itemColor]);
  const dangerColor = useMemo(() => HexToHueConverter(customization?.dangerColor), [customization?.dangerColor]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        fontSize: 12,
        height: '100%',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          padding: staticValues[15],
          gap: 10,
        }}
      >
        <div>
          <svg width="40px" height="40px" viewBox="0 0 61.7998 61.7998" xmlns="http://www.w3.org/2000/svg">
            <title />

            <g data-name="Layer 2" id="Layer_2">
              <g data-name="—ÎÓÈ 1" id="_ÎÓÈ_1">
                <circle cx="30.8999" cy="30.8999" fill="#58b0e0" r="30.8999" />

                <path d="M23.255 38.68l15.907.121v12.918l-15.907-.121V38.68z" fill="#f9dca4" fill-rule="evenodd" />

                <path
                  d="M43.971 58.905a30.967 30.967 0 0 1-25.843.14V48.417H43.97z"
                  fill="#e6e6e6"
                  fill-rule="evenodd"
                />

                <path
                  d="M33.403 61.7q-1.238.099-2.503.1-.955 0-1.895-.057l1.03-8.988h2.41z"
                  fill="#e9573e"
                  fill-rule="evenodd"
                />

                <path
                  d="M25.657 61.332A34.072 34.072 0 0 1 15.9 57.92a31.033 31.033 0 0 1-7.857-6.225l1.284-3.1 13.925-6.212c0 5.212 1.711 13.482 2.405 18.95z"
                  fill="#677079"
                  fill-rule="evenodd"
                />

                <path
                  d="M39.165 38.759v3.231c-4.732 5.527-13.773 4.745-15.8-3.412z"
                  fill-rule="evenodd"
                  opacity="0.11"
                />

                <path
                  d="M31.129 8.432c21.281 0 12.987 35.266 0 35.266-12.267 0-21.281-35.266 0-35.266z"
                  fill="#ffe8be"
                  fill-rule="evenodd"
                />

                <path
                  d="M18.365 24.046c-3.07 1.339-.46 7.686 1.472 7.658a31.972 31.972 0 0 1-1.472-7.659z"
                  fill="#f9dca4"
                  fill-rule="evenodd"
                />

                <path
                  d="M44.14 24.045c3.07 1.339.46 7.687-1.471 7.658a31.993 31.993 0 0 0 1.471-7.658z"
                  fill="#f9dca4"
                  fill-rule="evenodd"
                />

                <path
                  d="M21.931 14.328c-3.334 3.458-2.161 13.03-2.161 13.03l-1.05-.495c-6.554-25.394 31.634-25.395 25.043 0l-1.05.495s1.174-9.572-2.16-13.03c-4.119 3.995-14.526 3.974-18.622 0z"
                  fill="#464449"
                  fill-rule="evenodd"
                />

                <path
                  d="M36.767 61.243a30.863 30.863 0 0 0 17.408-10.018l-1.09-2.631-13.924-6.212c0 5.212-1.7 13.393-2.394 18.861z"
                  fill="#677079"
                  fill-rule="evenodd"
                />

                <path
                  d="M39.162 41.98l-7.926 6.465 6.573 5.913s1.752-9.704 1.353-12.378z"
                  fill="#ffffff"
                  fill-rule="evenodd"
                />

                <path
                  d="M23.253 41.98l7.989 6.465-6.645 5.913s-1.746-9.704-1.344-12.378z"
                  fill="#ffffff"
                  fill-rule="evenodd"
                />

                <path
                  d="M28.109 51.227l3.137-2.818 3.137 2.818-3.137 2.817-3.137-2.817z"
                  fill="#e9573e"
                  fill-rule="evenodd"
                />

                <path
                  d="M25.767 61.373a30.815 30.815 0 0 1-3.779-.88 2.652 2.652 0 0 1-.114-.093l-3.535-6.39 4.541-3.26h-4.752l1.017-6.851 4.11-2.599c.178 7.37 1.759 15.656 2.512 20.073z"
                  fill="#434955"
                  fill-rule="evenodd"
                />

                <path
                  d="M36.645 61.266c.588-.098 1.17-.234 1.747-.384.682-.177 1.36-.377 2.034-.579l.134-.043 3.511-6.315-4.541-3.242h4.752l-1.017-6.817-4.11-2.586c-.178 7.332-1.758 15.571-2.51 19.966z"
                  fill="#434955"
                  fill-rule="evenodd"
                />
              </g>
            </g>
          </svg>
        </div>
        <div style={{ flex: 1, flexDirection: 'column', textAlign: 'left' }}>
          <div style={{ color: 'var(--secondaryThemeColor)', fontWeight: 'bold', fontSize: staticValues[12] }}>
            İsim Soyisim
          </div>
          <div style={{ color: 'var(--secondaryThemeColor)', fontSize: staticValues[10] }}>email@email.com</div>
        </div>
        <div
          style={{
            backgroundColor: 'var(--thirdThemeColor)',
            paddingTop: staticValues[5],
            paddingBottom: staticValues[5],
            paddingRight: staticValues[5],
            paddingLeft: staticValues[5],
            borderRadius: 50,
          }}
        >
          <svg
            fill="var(--fourthThemeColor)"
            xmlns="http://www.w3.org/2000/svg"
            width="15px"
            height="15px"
            viewBox="0 0 1.3 1.3"
            enable-background="new 0 0 52 52"
          >
            <g>
              <path d="m0.238 0.835 0.223 0.223c0.01 0.01 0.025 0.01 0.035 0L1.05 0.5c0.01 -0.01 0.01 -0.025 0 -0.035l-0.22 -0.22c-0.01 -0.01 -0.025 -0.01 -0.035 0L0.238 0.803c-0.01 0.01 -0.01 0.025 0 0.033" />
              <path d="M0.903 0.143c-0.01 0.01 -0.01 0.025 0 0.035l0.22 0.22c0.01 0.01 0.025 0.01 0.035 0l0.063 -0.063c0.04 -0.038 0.04 -0.098 0 -0.138l-0.118 -0.118c-0.04 -0.04 -0.102 -0.04 -0.143 0z" />
              <path d="M0.053 1.205c-0.005 0.025 0.017 0.048 0.043 0.043l0.273 -0.065c0.01 -0.003 0.017 -0.007 0.023 -0.013l0.005 -0.005c0.005 -0.005 0.007 -0.023 -0.003 -0.033l-0.225 -0.225c-0.01 -0.01 -0.028 -0.007 -0.033 -0.003l-0.005 0.005c-0.007 0.007 -0.01 0.015 -0.013 0.023z" />
            </g>
          </svg>
        </div>
      </div>
      <div
        style={{
          flex: 1,
          height: '100%',
          paddingTop: staticValues[10],
        }}
      >
        {customization?.items?.map(customizationItem => {
          return (
            <>
              {customizationItem?.visible !== false && (
                <div
                  key={customization?.id}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    paddingTop: staticValues[5],
                    paddingBottom: staticValues[5],
                    marginLeft: staticValues[15],
                    marginRight: staticValues[15],
                    marginBottom: staticValues[10],
                    gap: 10,
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'var(--secondaryThemeColor)',
                    borderRadius: 10,
                  }}
                >
                  <div style={{ paddingLeft: staticValues[10] }}>
                    <img style={{ filter: itemColor }} className="w-[20px] h-[20px]" src={customizationItem.url} />
                  </div>
                  <div style={{ flex: 1, flexDirection: 'column', textAlign: 'left' }}>
                    <div style={{ fontWeight: 500, fontSize: 16, color: customization?.itemColor }}>
                      {customizationItem.name}
                    </div>
                    <div>{customizationItem.description}</div>
                  </div>
                  <div style={{ paddingRight: staticValues[5] }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9 5L15 12L9 19"
                        stroke={customization?.itemColor}
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </>
          );
        })}

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            paddingTop: staticValues[5],
            paddingBottom: staticValues[5],
            marginLeft: staticValues[15],
            marginRight: staticValues[15],
            marginBottom: staticValues[10],
            gap: 10,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'var(--secondaryThemeColor)',
            borderRadius: 10,
          }}
        >
          <div style={{ paddingLeft: staticValues[10] }}>
            <img style={{ filter: dangerColor }} className="w-[20px] h-[20px]" src={customization.logoutIcon} />
          </div>
          <div style={{ flex: 1, flexDirection: 'column', textAlign: 'left' }}>
            <div style={{ fontWeight: 500, fontSize: 16, color: customization?.dangerColor }}>Logout</div>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            paddingTop: staticValues[5],
            paddingBottom: staticValues[5],
            marginLeft: staticValues[15],
            marginRight: staticValues[15],
            marginBottom: staticValues[10],
            gap: 10,
            border: '1px solid #E5E5E5',
            borderRadius: 10,
          }}
        >
          <div style={{ paddingLeft: staticValues[10] }}>
            <img style={{ filter: dangerColor }} className="w-[20px] h-[20px]" src={customization.deleteIcon} />
          </div>
          <div style={{ flex: 1, flexDirection: 'column', textAlign: 'left' }}>
            <div style={{ fontWeight: 500, fontSize: 16, color: customization?.dangerColor }}>Delete the Account</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile_4;
